import RequesterV1 from "@/components/api/v1/requester.js";

export default {

  fetchAgroExporterProcess(producer_id, agro_exporter_process_id) {
    return RequesterV1.get(
      `producer/reporting/liquidations/show_reports/${producer_id}/fetch_agro_exporter_process/${agro_exporter_process_id}`
    );
  },

  fetchSummary(producer_id, agro_exporter_process_id) {
    return RequesterV1.get(
      `producer/reporting/liquidations/show_reports/${producer_id}/fetch_summary/${agro_exporter_process_id}`
    );
  },

  fetchTotalAdvances(producer_id, agro_exporter_process_id) {
    return RequesterV1.get(
      `producer/reporting/liquidations/show_reports/${producer_id}/fetch_total_advances/${agro_exporter_process_id}`
    );
  },

  fetchDiscardedMotives(producer_id, agro_exporter_process_id) {
    return RequesterV1.get(
      `producer/reporting/liquidations/show_reports/${producer_id}/fetch_discarded_motives/${agro_exporter_process_id}`
    );
  },

  fetchHarvestsMonthly(producer_id, agro_exporter_process_id) {
    return RequesterV1.get(
      `producer/reporting/liquidations/show_reports/${producer_id}/fetch_harvests_monthly/${agro_exporter_process_id}`
    );
  },

  fetchHarvestsWeekly(producer_id, agro_exporter_process_id) {
    return RequesterV1.get(
      `producer/reporting/liquidations/show_reports/${producer_id}/fetch_harvests_weekly/${agro_exporter_process_id}`
    );
  },

  fetchTotalsMonthly(producer_id, agro_exporter_process_id) {
    return RequesterV1.get(
      `producer/reporting/liquidations/show_reports/${producer_id}/fetch_totals_monthly/${agro_exporter_process_id}`
    );
  },

  fetchTotalsWeekly(producer_id, agro_exporter_process_id) {
    return RequesterV1.get(
      `producer/reporting/liquidations/show_reports/${producer_id}/fetch_totals_weekly/${agro_exporter_process_id}`
    );
  },

  fetchCropSizeWeekly(producer_id, agro_exporter_process_id) {
    return RequesterV1.get(
      `producer/reporting/liquidations/show_reports/${producer_id}/fetch_crop_size_weekly/${agro_exporter_process_id}`
    );
  },

  fetchCropSizeLabels(producer_id, agro_exporter_process_id) {
    return RequesterV1.get(
      `producer/reporting/liquidations/show_reports/${producer_id}/fetch_crop_size_labels/${agro_exporter_process_id}`
    );
  },

  fetchBoxesWeekly(producer_id, agro_exporter_process_id) {
    return RequesterV1.get(
      `producer/reporting/liquidations/show_reports/${producer_id}/fetch_boxes_weekly/${agro_exporter_process_id}`
    );
  },

  fetchKgWeekly(producer_id, agro_exporter_process_id) {
    return RequesterV1.get(
      `producer/reporting/liquidations/show_reports/${producer_id}/fetch_kg_weekly/${agro_exporter_process_id}`
    );
  },

  fetchCropSizes(producer_id, agro_exporter_process_id) {
    return RequesterV1.get(
      `producer/reporting/liquidations/show_reports/${producer_id}/fetch_crop_sizes/${agro_exporter_process_id}`
    );
  },

  fetchLiquidations(producer_id, agro_exporter_process_id, current_page, rows_per_page) {
    return RequesterV1.get(
      `producer/reporting/liquidations/show_reports/${producer_id}/fetch_harvested_batches/${agro_exporter_process_id}/${current_page}/${rows_per_page}`
    );
  },

  fetchLiquidationsTotal(producer_id, agro_exporter_process_id) {
    return RequesterV1.get(
      `producer/reporting/liquidations/show_reports/${producer_id}/fetch_harvested_batches_total/${agro_exporter_process_id}`
    );
  },

  fetchHarvestedBatch(producer_id, agro_exporter_process_id, liquidation_code) {
    return RequesterV1.get(
      `producer/reporting/liquidations/show_reports/${producer_id}/fetch_harvested_batch/${agro_exporter_process_id}/${liquidation_code}`
    );
  }
}
